import axiosInstance from './axiosInstance';

export const authApi = {};

export const manualApi = {
  getAllManuals: data => {
    const query = new URLSearchParams(data);
    return axiosInstance.get(`/cedu/books?${query}`);
  },
  getMyManuals: data => {
    const query = new URLSearchParams(data);
    return axiosInstance.get(`/mybooks?${query}`);
  },
  addMyManual: data => axiosInstance.post('/mybooks', { ...data }),
  deleteMyManual: id => axiosInstance.delete(`/mybooks/${id}`),
  getParentCategories: () => axiosInstance.get('/cedu/category'),
  getChildCategories: parentId =>
    axiosInstance.get(`/cedu/category/${parentId}`),
  addStudentManual: data => {
    return axiosInstance.post('/mybooks/student', { ...data });
  },
  getTestPaperList: data => {
    const query = new URLSearchParams(data);
    return axiosInstance.get(`/exam?${query}`);
  },
  removeTestPaper: id => {
    return axiosInstance.delete(`/exam/${id}`);
  },
  getTestPaperDetail: id => {
    return axiosInstance.get(`/exam/${id}`);
  },
  addBookmark: data => {
    return axiosInstance.post('/favorite/books', { ...data });
  },
  getBookmarkList: () => {
    return axiosInstance.get(`/favorite/books`);
  },
  removeBookmark: id => {
    return axiosInstance.delete(`/favorite/books/${id}`);
  },
};

export const vocabularyApi = {
  getUnits: bookIdx => {
    return axiosInstance.get(`/cedu/units/${bookIdx}`);
  },
  getVocas: data => axiosInstance.post('/problems/vocas', { ...data }),
  createTestPaper: data =>
    axiosInstance.post('/problems/generateQuestions', { ...data }),
  pdfGenerate: htmlContent =>
    axiosInstance.post(
      '/pdf/generate-pdf',
      { htmlContent },
      { responseType: 'arraybuffer' },
    ),
  saveTestPaper: data => {
    return axiosInstance.post('/exam', data);
  },
  updateTestPaper: (examId, data) => {
    return axiosInstance.put(`/exam/${examId}`, data);
  },
  saveLogo: data => {
    return axiosInstance.post('/exam/logo', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  getSignedUrl: fileKey => {
    return axiosInstance.get(`/exam/logo/signedurl/${fileKey}`);
  },
  generateMp3CombinedFile: data => {
    return axiosInstance.post('/vocaAudio', data);
  },
  downloadMp3CombinedFile: audioId => {
    return axiosInstance.get(`/vocaAudio/${audioId}`, {
      responseType: 'blob',
    });
  },
};
